import tokens from "./tokens.json";

export type WidgetThemeMode = "light" | "dark";

/** Resolves an explicit widget mode or follows the host app/system preference. */
export function resolveWidgetTheme(theme?: string | null): WidgetThemeMode {
  if (theme === "dark") return "dark";
  if (theme === "light") return "light";
  if (typeof document !== "undefined" && document.documentElement.dataset.theme === "dark") return "dark";
  if (typeof document !== "undefined" && document.documentElement.dataset.theme === "light") return "light";
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

/** Runtime variables shared by the framework-free booking and concierge widgets. */
export const WIDGET_THEME_VARS = `
:host {
  --ui-bg: ${tokens.color.paper};
  --ui-surface: #ffffff;
  --ui-surface-subtle: ${tokens.color.mist};
  --ui-text: ${tokens.color.ink};
  --ui-muted: ${tokens.color.muted};
  --ui-primary: var(--kuroo-brand-primary, ${tokens.color.violet});
  --ui-primary-strong: var(--kuroo-brand-primary-strong, #5144D6);
  --ui-accent: var(--kuroo-brand-accent, ${tokens.color.cyan});
  --ui-border: #E4E0E7;
  --ui-focus: var(--kuroo-brand-primary, #5144D6);
  --ui-success: ${tokens.color.success};
  --ui-warning: ${tokens.color.warning};
  --ui-danger: ${tokens.color.danger};
  --ui-on-primary: #FFFFFF;
  --ui-radius-sm: ${tokens.radius.sm};
  --ui-radius-md: ${tokens.radius.md};
  --ui-shadow-soft: ${tokens.shadow.soft};
  --ui-shadow-lift: ${tokens.shadow.lift};
  --k-font-display: ${tokens.type.display};
  --k-font-ui: ${tokens.type.ui};
  --k-motion-fast: ${tokens.motion.fast};
  --k-motion-standard: ${tokens.motion.standard};
  --k-motion-ease: ${tokens.motion.ease};
}
:host([data-theme="dark"]) {
  --ui-bg: #111017;
  --ui-surface: #1B1922;
  --ui-surface-subtle: #25222D;
  --ui-text: #F7F4F1;
  --ui-muted: #B5AFBD;
  --ui-primary: var(--kuroo-brand-primary-dark, var(--kuroo-brand-primary, #9A8FFF));
  --ui-primary-strong: #B5ADFF;
  --ui-accent: var(--kuroo-brand-accent-dark, var(--kuroo-brand-accent, #63E6F5));
  --ui-border: #383341;
  --ui-focus: var(--kuroo-brand-primary-dark, var(--kuroo-brand-primary, #C8C2FF));
  --ui-on-primary: #17151D;
  --ui-shadow-soft: 0 12px 34px rgba(0, 0, 0, .24);
  --ui-shadow-lift: 0 24px 70px rgba(0, 0, 0, .36);
}
@media (prefers-color-scheme: dark) {
  :host([data-theme="default"]), :host([data-theme="kuroo"]) {
    --ui-bg: #111017;
    --ui-surface: #1B1922;
    --ui-surface-subtle: #25222D;
    --ui-text: #F7F4F1;
    --ui-muted: #B5AFBD;
    --ui-primary: var(--kuroo-brand-primary-dark, var(--kuroo-brand-primary, #9A8FFF));
    --ui-primary-strong: #B5ADFF;
    --ui-accent: var(--kuroo-brand-accent-dark, var(--kuroo-brand-accent, #63E6F5));
    --ui-border: #383341;
    --ui-focus: var(--kuroo-brand-primary-dark, var(--kuroo-brand-primary, #C8C2FF));
    --ui-on-primary: #17151D;
    --ui-shadow-soft: 0 12px 34px rgba(0, 0, 0, .24);
    --ui-shadow-lift: 0 24px 70px rgba(0, 0, 0, .36);
  }
}
`;
